import { ActionTypes } from "../constants/actionTypes";

const initialState = {
  allRiders: [],
};

export default function riderReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.GET_RIDER_DETAILS:
      return {
        ...state,
        allRiders: [...payload],
      };
    case ActionTypes.CLEAR_RIDER_DETAILS:
      return {
        ...state,
        allRiders: [],
      };
    default:
      return state;
  }
}
